import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
} from 'devextreme-react/data-grid';
import { Format } from "devextreme-react/number-box";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarJurosDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class JurosBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                    <PaginaToolbar titulo="Cadastro de Juros">
                        <DataGrid
                            dataSource={criarJurosDs()}
                            showBorders={true}
                            rowAlternationEnabled={true} remoteOperations={true} 
                            focusedRowEnabled={true}
                            onInitNewRow={this.initNewRow}>
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />
                            <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                            <Column dataField={'ano'} />
                            <Column dataField={'mes'} />
                            <Column dataField={'valor'}>
                                <Format type={"fixedPoint"} precision={4} />
                            </Column>
                            <Paging defaultPageSize={20} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 20, 30]}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
        );
    }

    initNewRow(e){
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}
